import { LoadStatus, PortalStore, portalStoreToken } from '@servicetitan/cp-ui';
import { inject, injectable } from '@servicetitan/react-ioc';
import { makeObservable, observable, runInAction } from 'mobx';
import { DashboardApi } from '../api';
import {
    InvoiceSearchPaidStatus,
    InvoiceSearchPaymentMethod,
    InvoiceSearchRequest,
    InvoiceSearchResult,
    InvoiceSearchShowMode,
    InvoiceSearchSortField,
} from '../api/portal-invoices.api';
import { InvoicesSettingsFiltersStore } from './invoices-settings-filters.store';

@injectable()
export class DashboardInvoicesStore {
    @observable loadStatus = LoadStatus.Loading;
    @observable invoiceData: InvoiceSearchResult | null = null;

    constructor(
        @inject(portalStoreToken) private portalStore: PortalStore,
        @inject(DashboardApi) private dashboardApi: DashboardApi,
        @inject(InvoicesSettingsFiltersStore)
        private invoicesSettingsFiltersStore: InvoicesSettingsFiltersStore
    ) {
        makeObservable(this);
    }

    async loadInvoices(serviceLocationIds?: number[]) {
        runInAction(() => (this.loadStatus = LoadStatus.Loading));

        try {
            const searchRequest: InvoiceSearchRequest = {
                pageSize: 3,
                pageNumber: 1,
                includeTotalCount: true,
                orderBy: InvoiceSearchSortField.DueDate,
                orderByDesc: true,
                showMode: InvoiceSearchShowMode.Unpaid,
                customerPortalInvoiceFilter: this.invoicesSettingsFiltersStore.settingsFilterFlags,
                paidStatus: InvoiceSearchPaidStatus.Any,
                paymentMethod: InvoiceSearchPaymentMethod.Any,
                serviceLocationIds: serviceLocationIds?.length ? serviceLocationIds : undefined,
            };
            const invoiceData = await this.dashboardApi.invoice.searchInvoices(searchRequest);

            runInAction(() => {
                this.invoiceData = invoiceData.data;
                this.loadStatus = LoadStatus.Ok;
            });
        } catch {
            this.showErrorMessage();
            runInAction(() => {
                this.loadStatus = LoadStatus.Error;
            });
        }
    }

    private showErrorMessage() {
        this.portalStore.event('notify', {
            title: 'An error occurred',
            description: 'Please, try again later.',
            status: 'critical',
        });
    }
}
